module.exports = __webpack_public_path__ + "img/7c4ef39.jpg";